/**
 * PocketPills Adapter Configuration
 *
 * Defines the adapter configuration for PocketPills integration.
 * This config registers Lambda-invoked functions that can be called from workflows.
 */
import { IAdapterConfig } from '@care-portals/api-interfaces';

export const PocketPillsConfig: IAdapterConfig = {
  pocketpills: {
    label: 'PocketPills',
    functions: {
      createOrder: {
        middlewareHandler: `pocketpills`,
        version: 2,
        label: 'Create Order',
        params: [
          {
            key: 'prescriptionId',
            type: 'string',
            label: 'Prescription ID',
            placeholder: 'Enter the prescription ID'
          }
        ],
        passPayload: false
      },
      confirmPayment: {
        middlewareHandler: `pocketpills`,
        version: 2,
        label: 'Confirm Payment',
        params: [
          {
            key: 'orderId',
            type: 'string',
            label: 'PocketPills Order ID',
            placeholder: 'Enter the PocketPills order ID'
          }
        ],
        passPayload: false
      },
      handleWebhook: {
        middlewareHandler: `pocketpills`,
        version: 2,
        label: 'Handle Webhook',
        params: [],
        passPayload: true
      }
    }
  }
};
